var map = {
	"./background.webp": 87477,
	"./clock-big.webp": 62662,
	"./clock-small.webp": 24539,
	"./clouds.webp": 51659,
	"./community-created-content.webp": 71827,
	"./dawn.webp": 27483,
	"./death.webp": 61509,
	"./demon-head.webp": 62349,
	"./demon-head2.webp": 35677,
	"./demoninfo.webp": 52952,
	"./dusk.webp": 23700,
	"./editions/bmr.webp": 95996,
	"./editions/custom.webp": 49156,
	"./editions/snv.webp": 36768,
	"./editions/tb.webp": 43157,
	"./gstone.webp": 37351,
	"./icons/official/bmr/apprentice.webp": 3753,
	"./icons/official/bmr/apprentice_e.webp": 44909,
	"./icons/official/bmr/apprentice_g.webp": 5667,
	"./icons/official/bmr/assassin_e.webp": 17783,
	"./icons/official/bmr/assassin_g.webp": 73265,
	"./icons/official/bmr/bishop.webp": 42239,
	"./icons/official/bmr/bishop_e.webp": 32799,
	"./icons/official/bmr/bishop_g.webp": 5369,
	"./icons/official/bmr/chambermaid_e.webp": 34467,
	"./icons/official/bmr/chambermaid_g.webp": 75437,
	"./icons/official/bmr/courtier_e.webp": 65515,
	"./icons/official/bmr/courtier_g.webp": 18037,
	"./icons/official/bmr/devilsadvocate_e.webp": 32988,
	"./icons/official/bmr/devilsadvocate_g.webp": 48990,
	"./icons/official/bmr/exorcist_e.webp": 71069,
	"./icons/official/bmr/exorcist_g.webp": 72851,
	"./icons/official/bmr/fool_e.webp": 40578,
	"./icons/official/bmr/fool_g.webp": 17824,
	"./icons/official/bmr/gambler_e.webp": 5120,
	"./icons/official/bmr/gambler_g.webp": 23266,
	"./icons/official/bmr/godfather_e.webp": 3442,
	"./icons/official/bmr/godfather_g.webp": 11952,
	"./icons/official/bmr/goon_e.webp": 39225,
	"./icons/official/bmr/goon_g.webp": 66655,
	"./icons/official/bmr/gossip_e.webp": 66335,
	"./icons/official/bmr/gossip_g.webp": 19129,
	"./icons/official/bmr/grandmother_e.webp": 61659,
	"./icons/official/bmr/grandmother_g.webp": 3461,
	"./icons/official/bmr/innkeeper_e.webp": 31203,
	"./icons/official/bmr/innkeeper_g.webp": 70445,
	"./icons/official/bmr/judge.webp": 12665,
	"./icons/official/bmr/judge_e.webp": 34845,
	"./icons/official/bmr/judge_g.webp": 62803,
	"./icons/official/bmr/lunatic_e.webp": 73804,
	"./icons/official/bmr/lunatic_g.webp": 72046,
	"./icons/official/bmr/mastermind_e.webp": 37448,
	"./icons/official/bmr/mastermind_g.webp": 39050,
	"./icons/official/bmr/matron.webp": 14111,
	"./icons/official/bmr/matron_e.webp": 83167,
	"./icons/official/bmr/matron_g.webp": 35961,
	"./icons/official/bmr/minstrel_e.webp": 57488,
	"./icons/official/bmr/minstrel_g.webp": 6226,
	"./icons/official/bmr/moonchild_e.webp": 95927,
	"./icons/official/bmr/moonchild_g.webp": 89329,
	"./icons/official/bmr/pacifist_e.webp": 47803,
	"./icons/official/bmr/pacifist_g.webp": 73253,
	"./icons/official/bmr/po_e.webp": 17051,
	"./icons/official/bmr/po_g.webp": 1701,
	"./icons/official/bmr/professor_e.webp": 73083,
	"./icons/official/bmr/professor_g.webp": 41381,
	"./icons/official/bmr/pukka_e.webp": 55674,
	"./icons/official/bmr/pukka_g.webp": 23320,
	"./icons/official/bmr/sailor_e.webp": 2698,
	"./icons/official/bmr/sailor_g.webp": 47176,
	"./icons/official/bmr/shabaloth_e.webp": 43584,
	"./icons/official/bmr/shabaloth_g.webp": 13314,
	"./icons/official/bmr/tealady_e.webp": 89668,
	"./icons/official/bmr/tealady_g.webp": 38086,
	"./icons/official/bmr/tinker_e.webp": 43269,
	"./icons/official/bmr/tinker_g.webp": 1691,
	"./icons/official/bmr/voudon.webp": 5829,
	"./icons/official/bmr/voudon_e.webp": 86409,
	"./icons/official/bmr/voudon_g.webp": 83375,
	"./icons/official/bmr/zombuul_e.webp": 41104,
	"./icons/official/bmr/zombuul_g.webp": 59218,
	"./icons/official/carousel/acrobat_e.webp": 7303,
	"./icons/official/carousel/acrobat_g.webp": 77793,
	"./icons/official/carousel/alchemist_e.webp": 93297,
	"./icons/official/carousel/alchemist_g.webp": 57047,
	"./icons/official/carousel/alhadikhia_e.webp": 63271,
	"./icons/official/carousel/alhadikhia_g.webp": 90689,
	"./icons/official/carousel/alsaahir_e.webp": 82560,
	"./icons/official/carousel/alsaahir_g.webp": 84354,
	"./icons/official/carousel/amnesiac_e.webp": 12636,
	"./icons/official/carousel/amnesiac_g.webp": 17022,
	"./icons/official/carousel/atheist_e.webp": 15783,
	"./icons/official/carousel/atheist_g.webp": 86273,
	"./icons/official/carousel/balloonist_e.webp": 64406,
	"./icons/official/carousel/balloonist_g.webp": 5172,
	"./icons/official/carousel/banshee_e.webp": 25049,
	"./icons/official/carousel/banshee_g.webp": 61311,
	"./icons/official/carousel/boffin_e.webp": 88723,
	"./icons/official/carousel/boffin_g.webp": 5789,
	"./icons/official/carousel/boomdandy_e.webp": 86660,
	"./icons/official/carousel/boomdandy_g.webp": 58822,
	"./icons/official/carousel/bountyhunter_e.webp": 2706,
	"./icons/official/carousel/bountyhunter_g.webp": 11216,
	"./icons/official/carousel/cacklejack.webp": 10485,
	"./icons/official/carousel/cacklejack_e.webp": 25785,
	"./icons/official/carousel/cacklejack_g.webp": 53215,
	"./icons/official/carousel/cannibal_e.webp": 84485,
	"./icons/official/carousel/cannibal_g.webp": 42683,
	"./icons/official/carousel/choirboy_e.webp": 53880,
	"./icons/official/carousel/choirboy_g.webp": 78778,
	"./icons/official/carousel/cultleader_e.webp": 90014,
	"./icons/official/carousel/cultleader_g.webp": 88412,
	"./icons/official/carousel/damsel_e.webp": 33005,
	"./icons/official/carousel/damsel_g.webp": 77411,
	"./icons/official/carousel/deusexfiasco.webp": 61062,
	"./icons/official/carousel/engineer_e.webp": 65442,
	"./icons/official/carousel/engineer_g.webp": 95712,
	"./icons/official/carousel/farmer_e.webp": 34144,
	"./icons/official/carousel/farmer_g.webp": 30562,
	"./icons/official/carousel/fearmonger_e.webp": 79113,
	"./icons/official/carousel/fearmonger_g.webp": 41839,
	"./icons/official/carousel/ferryman.webp": 15455,
	"./icons/official/carousel/fisherman_e.webp": 39418,
	"./icons/official/carousel/fisherman_g.webp": 7064,
	"./icons/official/carousel/gangster.webp": 77116,
	"./icons/official/carousel/gangster_e.webp": 42148,
	"./icons/official/carousel/gangster_g.webp": 90566,
	"./icons/official/carousel/general_e.webp": 8893,
	"./icons/official/carousel/general_g.webp": 91827,
	"./icons/official/carousel/gnome.webp": 95005,
	"./icons/official/carousel/gnome_e.webp": 51665,
	"./icons/official/carousel/gnome_g.webp": 58263,
	"./icons/official/carousel/goblin_e.webp": 51064,
	"./icons/official/carousel/goblin_g.webp": 92314,
	"./icons/official/carousel/golem_e.webp": 30093,
	"./icons/official/carousel/golem_g.webp": 89123,
	"./icons/official/carousel/harpy_e.webp": 42053,
	"./icons/official/carousel/harpy_g.webp": 251,
	"./icons/official/carousel/hatter_e.webp": 86179,
	"./icons/official/carousel/hatter_g.webp": 76845,
	"./icons/official/carousel/heretic_e.webp": 31491,
	"./icons/official/carousel/heretic_g.webp": 87085,
	"./icons/official/carousel/hermit_e.webp": 57524,
	"./icons/official/carousel/hermit_g.webp": 7862,
	"./icons/official/carousel/highpriestess_e.webp": 54877,
	"./icons/official/carousel/highpriestess_g.webp": 37811,
	"./icons/official/carousel/huntsman_e.webp": 33541,
	"./icons/official/carousel/huntsman_g.webp": 91963,
	"./icons/official/carousel/kazali_e.webp": 85281,
	"./icons/official/carousel/kazali_g.webp": 74215,
	"./icons/official/carousel/king_e.webp": 89652,
	"./icons/official/carousel/king_g.webp": 22262,
	"./icons/official/carousel/knight_e.webp": 66322,
	"./icons/official/carousel/knight_g.webp": 17584,
	"./icons/official/carousel/legion_e.webp": 50657,
	"./icons/official/carousel/legion_g.webp": 23239,
	"./icons/official/carousel/leviathan_e.webp": 63407,
	"./icons/official/carousel/leviathan_g.webp": 43209,
	"./icons/official/carousel/lilmonsta_e.webp": 35384,
	"./icons/official/carousel/lilmonsta_g.webp": 51386,
	"./icons/official/carousel/lleech_e.webp": 39250,
	"./icons/official/carousel/lleech_g.webp": 47760,
	"./icons/official/carousel/lordoftyphon_e.webp": 89063,
	"./icons/official/carousel/lordoftyphon_g.webp": 16481,
	"./icons/official/carousel/lycanthrope_e.webp": 37354,
	"./icons/official/carousel/lycanthrope_g.webp": 19400,
	"./icons/official/carousel/magician_e.webp": 38738,
	"./icons/official/carousel/magician_g.webp": 73648,
	"./icons/official/carousel/marionette_e.webp": 37127,
	"./icons/official/carousel/marionette_g.webp": 64545,
	"./icons/official/carousel/mezepheles_e.webp": 51241,
	"./icons/official/carousel/mezepheles_g.webp": 31855,
	"./icons/official/carousel/nightwatchman_e.webp": 92474,
	"./icons/official/carousel/nightwatchman_g.webp": 76472,
	"./icons/official/carousel/noble_e.webp": 41261,
	"./icons/official/carousel/noble_g.webp": 76995,
	"./icons/official/carousel/ogre_e.webp": 72152,
	"./icons/official/carousel/ogre_g.webp": 97050,
	"./icons/official/carousel/ojo_e.webp": 97059,
	"./icons/official/carousel/ojo_g.webp": 52653,
	"./icons/official/carousel/organgrinder_e.webp": 63577,
	"./icons/official/carousel/organgrinder_g.webp": 62143,
	"./icons/official/carousel/pixie_e.webp": 83230,
	"./icons/official/carousel/pixie_g.webp": 14588,
	"./icons/official/carousel/plaguedoctor_e.webp": 44826,
	"./icons/official/carousel/plaguedoctor_g.webp": 12472,
	"./icons/official/carousel/politician_e.webp": 92277,
	"./icons/official/carousel/politician_g.webp": 77163,
	"./icons/official/carousel/poppygrower_e.webp": 85613,
	"./icons/official/carousel/poppygrower_g.webp": 46371,
	"./icons/official/carousel/preacher_e.webp": 63095,
	"./icons/official/carousel/preacher_g.webp": 2449,
	"./icons/official/carousel/princess_e.webp": 40500,
	"./icons/official/carousel/princess_g.webp": 42486,
	"./icons/official/carousel/psychopath_e.webp": 17536,
	"./icons/official/carousel/psychopath_g.webp": 97602,
	"./icons/official/carousel/puzzlemaster_e.webp": 71301,
	"./icons/official/carousel/puzzlemaster_g.webp": 86651,
	"./icons/official/carousel/riot_e.webp": 3569,
	"./icons/official/carousel/riot_g.webp": 47863,
	"./icons/official/carousel/shugenja_e.webp": 70002,
	"./icons/official/carousel/shugenja_g.webp": 78512,
	"./icons/official/carousel/snitch_e.webp": 78824,
	"./icons/official/carousel/snitch_g.webp": 96778,
	"./icons/official/carousel/steward_e.webp": 90045,
	"./icons/official/carousel/steward_g.webp": 14208,
	"./icons/official/carousel/summoner_e.webp": 9255,
	"./icons/official/carousel/summoner_g.webp": 79745,
	"./icons/official/carousel/villageidiot_e.webp": 1268,
	"./icons/official/carousel/villageidiot_g.webp": 67958,
	"./icons/official/carousel/vizier_e.webp": 43172,
	"./icons/official/carousel/vizier_g.webp": 15014,
	"./icons/official/carousel/widow_e.webp": 72379,
	"./icons/official/carousel/widow_g.webp": 14181,
	"./icons/official/carousel/wizard_e.webp": 77056,
	"./icons/official/carousel/wizard_g.webp": 57122,
	"./icons/official/carousel/wraith_e.webp": 1584,
	"./icons/official/carousel/wraith_g.webp": 93074,
	"./icons/official/carousel/xaan_e.webp": 73195,
	"./icons/official/carousel/xaan_g.webp": 25717,
	"./icons/official/carousel/yaggababble_e.webp": 37008,
	"./icons/official/carousel/yaggababble_g.webp": 2098,
	"./icons/official/carousel/zealot_e.webp": 40528,
	"./icons/official/carousel/zealot_g.webp": 32018,
	"./icons/official/fabled/angel.webp": 11036,
	"./icons/official/fabled/buddhist.webp": 63222,
	"./icons/official/fabled/djinn.webp": 35640,
	"./icons/official/fabled/doomsayer.webp": 12962,
	"./icons/official/fabled/duchess.webp": 47088,
	"./icons/official/fabled/fibbin.webp": 48045,
	"./icons/official/fabled/fiddler.webp": 94137,
	"./icons/official/fabled/hellslibrarian.webp": 26311,
	"./icons/official/fabled/revolutionary.webp": 90002,
	"./icons/official/fabled/sentinel.webp": 33295,
	"./icons/official/fabled/spiritofivory.webp": 30736,
	"./icons/official/fabled/toymaker.webp": 21439,
	"./icons/official/generic/custom.webp": 20793,
	"./icons/official/generic/custom_e.webp": 46525,
	"./icons/official/generic/custom_g.webp": 29459,
	"./icons/official/generic/demon.webp": 7857,
	"./icons/official/generic/demon_e.webp": 87557,
	"./icons/official/generic/demon_g.webp": 45979,
	"./icons/official/generic/evil.webp": 30456,
	"./icons/official/generic/fabled.webp": 96444,
	"./icons/official/generic/good.webp": 60247,
	"./icons/official/generic/loric.webp": 68999,
	"./icons/official/generic/minion.webp": 82324,
	"./icons/official/generic/minion_e.webp": 92332,
	"./icons/official/generic/minion_g.webp": 90574,
	"./icons/official/generic/outsider.webp": 74525,
	"./icons/official/generic/outsider_e.webp": 785,
	"./icons/official/generic/outsider_g.webp": 7383,
	"./icons/official/generic/townsfolk.webp": 47053,
	"./icons/official/generic/townsfolk_e.webp": 74369,
	"./icons/official/generic/townsfolk_g.webp": 3879,
	"./icons/official/generic/traveller.webp": 65097,
	"./icons/official/generic/traveller_e.webp": 53709,
	"./icons/official/generic/traveller_g.webp": 14467,
	"./icons/official/loric/bigwig.webp": 83497,
	"./icons/official/loric/bootlegger.webp": 63820,
	"./icons/official/loric/gardener.webp": 16332,
	"./icons/official/loric/godofug.webp": 60665,
	"./icons/official/loric/hindu.webp": 22682,
	"./icons/official/loric/knaves.webp": 84072,
	"./icons/official/loric/pope.webp": 25012,
	"./icons/official/loric/stormcatcher.webp": 56365,
	"./icons/official/loric/tor.webp": 88975,
	"./icons/official/loric/ventriloquist.webp": 62873,
	"./icons/official/loric/zenomancer.webp": 14430,
	"./icons/official/snv/artist_e.webp": 39653,
	"./icons/official/snv/artist_g.webp": 98075,
	"./icons/official/snv/barber_e.webp": 76960,
	"./icons/official/snv/barber_g.webp": 78754,
	"./icons/official/snv/barista.webp": 66760,
	"./icons/official/snv/barista_e.webp": 2464,
	"./icons/official/snv/barista_g.webp": 82530,
	"./icons/official/snv/bonecollector.webp": 891,
	"./icons/official/snv/bonecollector_e.webp": 50539,
	"./icons/official/snv/bonecollector_g.webp": 3061,
	"./icons/official/snv/butcher.webp": 60969,
	"./icons/official/snv/butcher_e.webp": 84013,
	"./icons/official/snv/butcher_g.webp": 36099,
	"./icons/official/snv/cerenovus_e.webp": 22142,
	"./icons/official/snv/cerenovus_g.webp": 53500,
	"./icons/official/snv/clockmaker_e.webp": 5132,
	"./icons/official/snv/clockmaker_g.webp": 3054,
	"./icons/official/snv/deviant.webp": 66829,
	"./icons/official/snv/deviant_e.webp": 63841,
	"./icons/official/snv/deviant_g.webp": 78951,
	"./icons/official/snv/dreamer_e.webp": 85814,
	"./icons/official/snv/dreamer_g.webp": 53204,
	"./icons/official/snv/eviltwin_e.webp": 15750,
	"./icons/official/snv/eviltwin_g.webp": 67332,
	"./icons/official/snv/fanggu_e.webp": 27852,
	"./icons/official/snv/fanggu_g.webp": 26094,
	"./icons/official/snv/flowergirl_e.webp": 47479,
	"./icons/official/snv/flowergirl_g.webp": 40881,
	"./icons/official/snv/harlot.webp": 42616,
	"./icons/official/snv/harlot_e.webp": 37520,
	"./icons/official/snv/harlot_g.webp": 29010,
	"./icons/official/snv/juggler_e.webp": 36272,
	"./icons/official/snv/juggler_g.webp": 85010,
	"./icons/official/snv/klutz_e.webp": 20386,
	"./icons/official/snv/klutz_g.webp": 50656,
	"./icons/official/snv/mathematician_e.webp": 69645,
	"./icons/official/snv/mathematician_g.webp": 21731,
	"./icons/official/snv/mutant_e.webp": 67997,
	"./icons/official/snv/mutant_g.webp": 50931,
	"./icons/official/snv/nodashii_e.webp": 88627,
	"./icons/official/snv/nodashii_g.webp": 44317,
	"./icons/official/snv/oracle_e.webp": 17552,
	"./icons/official/snv/oracle_g.webp": 82642,
	"./icons/official/snv/philosopher_e.webp": 9845,
	"./icons/official/snv/philosopher_g.webp": 94731,
	"./icons/official/snv/pithag_e.webp": 60621,
	"./icons/official/snv/pithag_g.webp": 12707,
	"./icons/official/snv/sage_e.webp": 55410,
	"./icons/official/snv/sage_g.webp": 6672,
	"./icons/official/snv/savant_e.webp": 80633,
	"./icons/official/snv/savant_g.webp": 8063,
	"./icons/official/snv/seamstress_e.webp": 31968,
	"./icons/official/snv/seamstress_g.webp": 50114,
	"./icons/official/snv/snakecharmer_e.webp": 88082,
	"./icons/official/snv/snakecharmer_g.webp": 69968,
	"./icons/official/snv/sweetheart_e.webp": 55782,
	"./icons/official/snv/sweetheart_g.webp": 83620,
	"./icons/official/snv/towncrier_e.webp": 18985,
	"./icons/official/snv/towncrier_g.webp": 15951,
	"./icons/official/snv/vigormortis_e.webp": 50263,
	"./icons/official/snv/vigormortis_g.webp": 5745,
	"./icons/official/snv/vortox_e.webp": 97344,
	"./icons/official/snv/vortox_g.webp": 15490,
	"./icons/official/snv/witch_e.webp": 14385,
	"./icons/official/snv/witch_g.webp": 58903,
	"./icons/official/tb/baron_e.webp": 78905,
	"./icons/official/tb/baron_g.webp": 77471,
	"./icons/official/tb/beggar.webp": 127,
	"./icons/official/tb/beggar_e.webp": 76127,
	"./icons/official/tb/beggar_g.webp": 28921,
	"./icons/official/tb/bureaucrat.webp": 86781,
	"./icons/official/tb/bureaucrat_e.webp": 33041,
	"./icons/official/tb/bureaucrat_g.webp": 93911,
	"./icons/official/tb/butler_e.webp": 81649,
	"./icons/official/tb/butler_g.webp": 88247,
	"./icons/official/tb/chef_e.webp": 41639,
	"./icons/official/tb/chef_g.webp": 8577,
	"./icons/official/tb/drunk_e.webp": 80519,
	"./icons/official/tb/drunk_g.webp": 91585,
	"./icons/official/tb/empath_e.webp": 16666,
	"./icons/official/tb/empath_g.webp": 53368,
	"./icons/official/tb/fortuneteller_e.webp": 35316,
	"./icons/official/tb/fortuneteller_g.webp": 85654,
	"./icons/official/tb/gunslinger.webp": 70067,
	"./icons/official/tb/gunslinger_e.webp": 23891,
	"./icons/official/tb/gunslinger_g.webp": 40957,
	"./icons/official/tb/imp_e.webp": 65519,
	"./icons/official/tb/imp_g.webp": 84905,
	"./icons/official/tb/investigator_e.webp": 22026,
	"./icons/official/tb/investigator_g.webp": 10184,
	"./icons/official/tb/librarian_e.webp": 91197,
	"./icons/official/tb/librarian_g.webp": 35507,
	"./icons/official/tb/mayor_e.webp": 18585,
	"./icons/official/tb/mayor_g.webp": 54847,
	"./icons/official/tb/monk_e.webp": 38900,
	"./icons/official/tb/monk_g.webp": 5590,
	"./icons/official/tb/poisoner_e.webp": 65016,
	"./icons/official/tb/poisoner_g.webp": 28314,
	"./icons/official/tb/ravenkeeper_e.webp": 52969,
	"./icons/official/tb/ravenkeeper_g.webp": 15695,
	"./icons/official/tb/recluse_e.webp": 72944,
	"./icons/official/tb/recluse_g.webp": 74706,
	"./icons/official/tb/saint_e.webp": 6000,
	"./icons/official/tb/saint_g.webp": 97490,
	"./icons/official/tb/scapegoat.webp": 47172,
	"./icons/official/tb/scapegoat_e.webp": 79196,
	"./icons/official/tb/scapegoat_g.webp": 95198,
	"./icons/official/tb/scarletwoman_e.webp": 18883,
	"./icons/official/tb/scarletwoman_g.webp": 74477,
	"./icons/official/tb/slayer_e.webp": 67081,
	"./icons/official/tb/slayer_g.webp": 29807,
	"./icons/official/tb/soldier_e.webp": 65063,
	"./icons/official/tb/soldier_g.webp": 49953,
	"./icons/official/tb/spy_e.webp": 18175,
	"./icons/official/tb/spy_g.webp": 90745,
	"./icons/official/tb/thief.webp": 65590,
	"./icons/official/tb/thief_e.webp": 77549,
	"./icons/official/tb/thief_g.webp": 86883,
	"./icons/official/tb/undertaker_e.webp": 74982,
	"./icons/official/tb/undertaker_g.webp": 2820,
	"./icons/official/tb/virgin_e.webp": 77498,
	"./icons/official/tb/virgin_g.webp": 36248,
	"./icons/official/tb/washerwoman_e.webp": 41047,
	"./icons/official/tb/washerwoman_g.webp": 77297,
	"./icons/unofficial/Alternate/acrobat.webp": 93080,
	"./icons/unofficial/Alternate/alchemist.webp": 26134,
	"./icons/unofficial/Alternate/alhadikhia.webp": 91830,
	"./icons/unofficial/Alternate/alsaahir.webp": 27925,
	"./icons/unofficial/Alternate/amnesiac.webp": 77653,
	"./icons/unofficial/Alternate/apprentice_e.webp": 32001,
	"./icons/unofficial/Alternate/apprentice_g.webp": 47111,
	"./icons/unofficial/Alternate/artist.webp": 69981,
	"./icons/unofficial/Alternate/assassin.webp": 99827,
	"./icons/unofficial/Alternate/atheist.webp": 1472,
	"./icons/unofficial/Alternate/balloonist.webp": 85447,
	"./icons/unofficial/Alternate/banshee.webp": 34330,
	"./icons/unofficial/Alternate/barber.webp": 32668,
	"./icons/unofficial/Alternate/barista_e.webp": 12412,
	"./icons/unofficial/Alternate/barista_g.webp": 97406,
	"./icons/unofficial/Alternate/baron.webp": 42870,
	"./icons/unofficial/Alternate/beggar_e.webp": 35054,
	"./icons/unofficial/Alternate/beggar_g.webp": 53484,
	"./icons/unofficial/Alternate/bishop_e.webp": 71675,
	"./icons/unofficial/Alternate/bishop_g.webp": 41605,
	"./icons/unofficial/Alternate/boffin.webp": 50278,
	"./icons/unofficial/Alternate/bonecollector_e.webp": 47463,
	"./icons/unofficial/Alternate/bonecollector_g.webp": 74881,
	"./icons/unofficial/Alternate/boomdandy.webp": 43535,
	"./icons/unofficial/Alternate/bountyhunter.webp": 37043,
	"./icons/unofficial/Alternate/bureaucrat_e.webp": 81272,
	"./icons/unofficial/Alternate/bureaucrat_g.webp": 44570,
	"./icons/unofficial/Alternate/butcher_e.webp": 55705,
	"./icons/unofficial/Alternate/butcher_g.webp": 2911,
	"./icons/unofficial/Alternate/butler.webp": 45376,
	"./icons/unofficial/Alternate/cacklejack_e.webp": 24420,
	"./icons/unofficial/Alternate/cacklejack_g.webp": 30214,
	"./icons/unofficial/Alternate/cannibal.webp": 92864,
	"./icons/unofficial/Alternate/cerenovus.webp": 80886,
	"./icons/unofficial/Alternate/chambermaid.webp": 93327,
	"./icons/unofficial/Alternate/chef.webp": 51078,
	"./icons/unofficial/Alternate/choirboy.webp": 97249,
	"./icons/unofficial/Alternate/clockmaker.webp": 40992,
	"./icons/unofficial/Alternate/courtier.webp": 39615,
	"./icons/unofficial/Alternate/cultleader.webp": 55075,
	"./icons/unofficial/Alternate/damsel.webp": 50352,
	"./icons/unofficial/Alternate/demon.webp": 9089,
	"./icons/unofficial/Alternate/deviant_e.webp": 30493,
	"./icons/unofficial/Alternate/deviant_g.webp": 58451,
	"./icons/unofficial/Alternate/devilsadvocate.webp": 84896,
	"./icons/unofficial/Alternate/dreamer.webp": 93598,
	"./icons/unofficial/Alternate/drunk.webp": 82388,
	"./icons/unofficial/Alternate/empath.webp": 72531,
	"./icons/unofficial/Alternate/engineer.webp": 57843,
	"./icons/unofficial/Alternate/eviltwin.webp": 12742,
	"./icons/unofficial/Alternate/exorcist.webp": 65429,
	"./icons/unofficial/Alternate/fanggu.webp": 5016,
	"./icons/unofficial/Alternate/farmer.webp": 43249,
	"./icons/unofficial/Alternate/fearmonger.webp": 61996,
	"./icons/unofficial/Alternate/fisherman.webp": 36821,
	"./icons/unofficial/Alternate/flowergirl.webp": 42235,
	"./icons/unofficial/Alternate/fool.webp": 2346,
	"./icons/unofficial/Alternate/fortuneteller.webp": 21727,
	"./icons/unofficial/Alternate/gambler.webp": 28324,
	"./icons/unofficial/Alternate/gangster_e.webp": 8373,
	"./icons/unofficial/Alternate/gangster_g.webp": 55851,
	"./icons/unofficial/Alternate/general.webp": 69098,
	"./icons/unofficial/Alternate/gnome_e.webp": 42886,
	"./icons/unofficial/Alternate/gnome_g.webp": 71044,
	"./icons/unofficial/Alternate/goblin.webp": 95137,
	"./icons/unofficial/Alternate/godfather.webp": 31842,
	"./icons/unofficial/Alternate/golem.webp": 64938,
	"./icons/unofficial/Alternate/goon.webp": 11001,
	"./icons/unofficial/Alternate/gossip.webp": 38947,
	"./icons/unofficial/Alternate/grandmother.webp": 50511,
	"./icons/unofficial/Alternate/gunslinger_e.webp": 15262,
	"./icons/unofficial/Alternate/gunslinger_g.webp": 82908,
	"./icons/unofficial/Alternate/harlot_e.webp": 57348,
	"./icons/unofficial/Alternate/harlot_g.webp": 29510,
	"./icons/unofficial/Alternate/harpy.webp": 18842,
	"./icons/unofficial/Alternate/hatter.webp": 29238,
	"./icons/unofficial/Alternate/heretic.webp": 82676,
	"./icons/unofficial/Alternate/hermit.webp": 93249,
	"./icons/unofficial/Alternate/highpriestess.webp": 6730,
	"./icons/unofficial/Alternate/huntsman.webp": 40864,
	"./icons/unofficial/Alternate/imp.webp": 93024,
	"./icons/unofficial/Alternate/innkeeper.webp": 92487,
	"./icons/unofficial/Alternate/investigator.webp": 13479,
	"./icons/unofficial/Alternate/judge_e.webp": 47801,
	"./icons/unofficial/Alternate/judge_g.webp": 46367,
	"./icons/unofficial/Alternate/juggler.webp": 10372,
	"./icons/unofficial/Alternate/kazali.webp": 63332,
	"./icons/unofficial/Alternate/king.webp": 32517,
	"./icons/unofficial/Alternate/klutz.webp": 99346,
	"./icons/unofficial/Alternate/knight.webp": 92415,
	"./icons/unofficial/Alternate/legion.webp": 81292,
	"./icons/unofficial/Alternate/leviathan.webp": 30512,
	"./icons/unofficial/Alternate/librarian.webp": 5038,
	"./icons/unofficial/Alternate/lilmonsta.webp": 88911,
	"./icons/unofficial/Alternate/lleech.webp": 78079,
	"./icons/unofficial/Alternate/lordoftyphon.webp": 23462,
	"./icons/unofficial/Alternate/lunatic.webp": 75264,
	"./icons/unofficial/Alternate/lycanthrope.webp": 76653,
	"./icons/unofficial/Alternate/magician.webp": 83883,
	"./icons/unofficial/Alternate/marionette.webp": 83258,
	"./icons/unofficial/Alternate/mastermind.webp": 4596,
	"./icons/unofficial/Alternate/mathematician.webp": 30221,
	"./icons/unofficial/Alternate/matron_e.webp": 66707,
	"./icons/unofficial/Alternate/matron_g.webp": 83773,
	"./icons/unofficial/Alternate/mayor.webp": 12630,
	"./icons/unofficial/Alternate/mezepheles.webp": 52208,
	"./icons/unofficial/Alternate/minion.webp": 98692,
	"./icons/unofficial/Alternate/minstrel.webp": 5588,
	"./icons/unofficial/Alternate/monk.webp": 33817,
	"./icons/unofficial/Alternate/moonchild.webp": 23331,
	"./icons/unofficial/Alternate/mutant.webp": 92925,
	"./icons/unofficial/Alternate/nightwatchman.webp": 71993,
	"./icons/unofficial/Alternate/noble.webp": 34390,
	"./icons/unofficial/Alternate/nodashii.webp": 57447,
	"./icons/unofficial/Alternate/ogre.webp": 27513,
	"./icons/unofficial/Alternate/ojo.webp": 62212,
	"./icons/unofficial/Alternate/oracle.webp": 96044,
	"./icons/unofficial/Alternate/organgrinder.webp": 92296,
	"./icons/unofficial/Alternate/outsider.webp": 44877,
	"./icons/unofficial/Alternate/pacifist.webp": 70991,
	"./icons/unofficial/Alternate/philosopher.webp": 7045,
	"./icons/unofficial/Alternate/pithag.webp": 27301,
	"./icons/unofficial/Alternate/pixie.webp": 76157,
	"./icons/unofficial/Alternate/plaguedoctor.webp": 93795,
	"./icons/unofficial/Alternate/po.webp": 12151,
	"./icons/unofficial/Alternate/poisoner.webp": 49893,
	"./icons/unofficial/Alternate/politician.webp": 20388,
	"./icons/unofficial/Alternate/poppygrower.webp": 29370,
	"./icons/unofficial/Alternate/preacher.webp": 34966,
	"./icons/unofficial/Alternate/princess.webp": 29373,
	"./icons/unofficial/Alternate/professor.webp": 2743,
	"./icons/unofficial/Alternate/psychopath.webp": 46377,
	"./icons/unofficial/Alternate/pukka.webp": 44386,
	"./icons/unofficial/Alternate/puzzlemaster.webp": 89912,
	"./icons/unofficial/Alternate/ravenkeeper.webp": 85722,
	"./icons/unofficial/Alternate/recluse.webp": 59079,
	"./icons/unofficial/Alternate/riot.webp": 33284,
	"./icons/unofficial/Alternate/sage.webp": 79602,
	"./icons/unofficial/Alternate/sailor.webp": 32146,
	"./icons/unofficial/Alternate/saint.webp": 34139,
	"./icons/unofficial/Alternate/savant.webp": 49657,
	"./icons/unofficial/Alternate/scapegoat_e.webp": 58859,
	"./icons/unofficial/Alternate/scapegoat_g.webp": 59573,
	"./icons/unofficial/Alternate/scarletwoman.webp": 32454,
	"./icons/unofficial/Alternate/seamstress.webp": 29156,
	"./icons/unofficial/Alternate/shabaloth.webp": 84300,
	"./icons/unofficial/Alternate/shugenja.webp": 49651,
	"./icons/unofficial/Alternate/slayer.webp": 65184,
	"./icons/unofficial/Alternate/snakecharmer.webp": 41122,
	"./icons/unofficial/Alternate/snitch.webp": 85529,
	"./icons/unofficial/Alternate/soldier.webp": 28080,
	"./icons/unofficial/Alternate/spy.webp": 58156,
	"./icons/unofficial/Alternate/steward.webp": 46138,
	"./icons/unofficial/Alternate/summoner.webp": 34741,
	"./icons/unofficial/Alternate/sweetheart.webp": 38966,
	"./icons/unofficial/Alternate/tealady.webp": 78888,
	"./icons/unofficial/Alternate/thief_e.webp": 22942,
	"./icons/unofficial/Alternate/thief_g.webp": 90588,
	"./icons/unofficial/Alternate/tinker.webp": 59117,
	"./icons/unofficial/Alternate/towncrier.webp": 12945,
	"./icons/unofficial/Alternate/townsfolk.webp": 18653,
	"./icons/unofficial/Alternate/traveller_e.webp": 76669,
	"./icons/unofficial/Alternate/traveller_g.webp": 59603,
	"./icons/unofficial/Alternate/undertaker.webp": 82691,
	"./icons/unofficial/Alternate/vigormortis.webp": 3435,
	"./icons/unofficial/Alternate/villageidiot.webp": 32421,
	"./icons/unofficial/Alternate/virgin.webp": 31363,
	"./icons/unofficial/Alternate/vizier.webp": 96973,
	"./icons/unofficial/Alternate/vortox.webp": 91988,
	"./icons/unofficial/Alternate/voudon_e.webp": 68221,
	"./icons/unofficial/Alternate/voudon_g.webp": 96179,
	"./icons/unofficial/Alternate/washerwoman.webp": 24968,
	"./icons/unofficial/Alternate/widow.webp": 13020,
	"./icons/unofficial/Alternate/witch.webp": 56257,
	"./icons/unofficial/Alternate/wizard.webp": 14325,
	"./icons/unofficial/Alternate/wraith.webp": 48269,
	"./icons/unofficial/Alternate/xaan.webp": 3030,
	"./icons/unofficial/Alternate/yaggababble.webp": 27735,
	"./icons/unofficial/Alternate/zealot.webp": 58593,
	"./icons/unofficial/Alternate/zombuul.webp": 50284,
	"./icons/unofficial/acrobat.webp": 83261,
	"./icons/unofficial/alchemist.webp": 61387,
	"./icons/unofficial/alhadikhia.webp": 45549,
	"./icons/unofficial/alsaahir.webp": 42930,
	"./icons/unofficial/amnesiac.webp": 77418,
	"./icons/unofficial/angel.webp": 5374,
	"./icons/unofficial/apprentice.webp": 45974,
	"./icons/unofficial/artist.webp": 54306,
	"./icons/unofficial/assassin.webp": 20524,
	"./icons/unofficial/atheist.webp": 63433,
	"./icons/unofficial/balloonist.webp": 50120,
	"./icons/unofficial/banshee.webp": 69967,
	"./icons/unofficial/barber.webp": 77271,
	"./icons/unofficial/barista.webp": 71377,
	"./icons/unofficial/baron.webp": 17251,
	"./icons/unofficial/beggar.webp": 8113,
	"./icons/unofficial/bigwig.webp": 6830,
	"./icons/unofficial/bishop.webp": 54328,
	"./icons/unofficial/boffin.webp": 46457,
	"./icons/unofficial/bonecollector.webp": 17814,
	"./icons/unofficial/boomdandy.webp": 91698,
	"./icons/unofficial/bootlegger.webp": 32727,
	"./icons/unofficial/bountyhunter.webp": 44268,
	"./icons/unofficial/buddhist.webp": 45316,
	"./icons/unofficial/bureaucrat.webp": 60671,
	"./icons/unofficial/butcher.webp": 73572,
	"./icons/unofficial/butler.webp": 25655,
	"./icons/unofficial/cacklejack.webp": 49703,
	"./icons/unofficial/cannibal.webp": 18611,
	"./icons/unofficial/cerenovus.webp": 87483,
	"./icons/unofficial/chambermaid.webp": 90598,
	"./icons/unofficial/chef.webp": 37977,
	"./icons/unofficial/choirboy.webp": 88934,
	"./icons/unofficial/clockmaker.webp": 81151,
	"./icons/unofficial/courtier.webp": 14904,
	"./icons/unofficial/cultleader.webp": 96484,
	"./icons/unofficial/custom.webp": 25458,
	"./icons/unofficial/damsel.webp": 27343,
	"./icons/unofficial/demon.webp": 58944,
	"./icons/unofficial/deusexfiasco.webp": 62412,
	"./icons/unofficial/deviant.webp": 75712,
	"./icons/unofficial/devilsadvocate.webp": 6955,
	"./icons/unofficial/djinn.webp": 80702,
	"./icons/unofficial/doomsayer.webp": 99796,
	"./icons/unofficial/dreamer.webp": 8699,
	"./icons/unofficial/drunk.webp": 15185,
	"./icons/unofficial/duchess.webp": 22790,
	"./icons/unofficial/empath.webp": 52560,
	"./icons/unofficial/engineer.webp": 65280,
	"./icons/unofficial/evil.webp": 22271,
	"./icons/unofficial/eviltwin.webp": 27961,
	"./icons/unofficial/exorcist.webp": 29442,
	"./icons/unofficial/fabled.webp": 41783,
	"./icons/unofficial/fanggu.webp": 11631,
	"./icons/unofficial/farmer.webp": 1958,
	"./icons/unofficial/fearmonger.webp": 88111,
	"./icons/unofficial/ferryman.webp": 76585,
	"./icons/unofficial/fibbin.webp": 95163,
	"./icons/unofficial/fiddler.webp": 22195,
	"./icons/unofficial/fisherman.webp": 65420,
	"./icons/unofficial/flowergirl.webp": 23768,
	"./icons/unofficial/fool.webp": 47709,
	"./icons/unofficial/fortuneteller.webp": 77254,
	"./icons/unofficial/gambler.webp": 64725,
	"./icons/unofficial/gangster.webp": 1282,
	"./icons/unofficial/gardener.webp": 13299,
	"./icons/unofficial/general.webp": 8307,
	"./icons/unofficial/gnome.webp": 74967,
	"./icons/unofficial/goblin.webp": 24962,
	"./icons/unofficial/godfather.webp": 64651,
	"./icons/unofficial/godofug.webp": 92032,
	"./icons/unofficial/golem.webp": 73031,
	"./icons/unofficial/good.webp": 45200,
	"./icons/unofficial/goon.webp": 85562,
	"./icons/unofficial/gossip.webp": 68288,
	"./icons/unofficial/grandmother.webp": 20094,
	"./icons/unofficial/gunslinger.webp": 55013,
	"./icons/unofficial/harlot.webp": 19879,
	"./icons/unofficial/harpy.webp": 13547,
	"./icons/unofficial/hatter.webp": 64625,
	"./icons/unofficial/hellslibrarian.webp": 97521,
	"./icons/unofficial/heretic.webp": 85233,
	"./icons/unofficial/hermit.webp": 3226,
	"./icons/unofficial/highpriestess.webp": 16563,
	"./icons/unofficial/hindu.webp": 25975,
	"./icons/unofficial/huntsman.webp": 22999,
	"./icons/unofficial/imp.webp": 66381,
	"./icons/unofficial/innkeeper.webp": 31830,
	"./icons/unofficial/investigator.webp": 74768,
	"./icons/unofficial/judge.webp": 35356,
	"./icons/unofficial/juggler.webp": 37597,
	"./icons/unofficial/kazali.webp": 38991,
	"./icons/unofficial/king.webp": 11786,
	"./icons/unofficial/klutz.webp": 98339,
	"./icons/unofficial/knaves.webp": 43491,
	"./icons/unofficial/knight.webp": 68980,
	"./icons/unofficial/legion.webp": 37059,
	"./icons/unofficial/leviathan.webp": 65797,
	"./icons/unofficial/librarian.webp": 8207,
	"./icons/unofficial/lilmonsta.webp": 50322,
	"./icons/unofficial/lleech.webp": 13108,
	"./icons/unofficial/lordoftyphon.webp": 4801,
	"./icons/unofficial/loric.webp": 47898,
	"./icons/unofficial/lunatic.webp": 74813,
	"./icons/unofficial/lycanthrope.webp": 54940,
	"./icons/unofficial/magician.webp": 32244,
	"./icons/unofficial/marionette.webp": 12581,
	"./icons/unofficial/mastermind.webp": 29755,
	"./icons/unofficial/mathematician.webp": 21748,
	"./icons/unofficial/matron.webp": 4976,
	"./icons/unofficial/mayor.webp": 31883,
	"./icons/unofficial/mezepheles.webp": 95167,
	"./icons/unofficial/minion.webp": 75595,
	"./icons/unofficial/minstrel.webp": 41695,
	"./icons/unofficial/monk.webp": 37594,
	"./icons/unofficial/moonchild.webp": 8642,
	"./icons/unofficial/mutant.webp": 77366,
	"./icons/unofficial/nightwatchman.webp": 76992,
	"./icons/unofficial/noble.webp": 72651,
	"./icons/unofficial/nodashii.webp": 33936,
	"./icons/unofficial/ogre.webp": 88542,
	"./icons/unofficial/ojo.webp": 5389,
	"./icons/unofficial/oracle.webp": 96207,
	"./icons/unofficial/organgrinder.webp": 38999,
	"./icons/unofficial/outsider.webp": 47046,
	"./icons/unofficial/pacifist.webp": 12356,
	"./icons/unofficial/philosopher.webp": 74356,
	"./icons/unofficial/pithag.webp": 90578,
	"./icons/unofficial/pixie.webp": 99960,
	"./icons/unofficial/plaguedoctor.webp": 10916,
	"./icons/unofficial/po.webp": 84016,
	"./icons/unofficial/poisoner.webp": 80598,
	"./icons/unofficial/politician.webp": 52823,
	"./icons/unofficial/pope.webp": 32543,
	"./icons/unofficial/poppygrower.webp": 63671,
	"./icons/unofficial/preacher.webp": 82661,
	"./icons/unofficial/princess.webp": 90106,
	"./icons/unofficial/professor.webp": 46974,
	"./icons/unofficial/psychopath.webp": 63406,
	"./icons/unofficial/pukka.webp": 39239,
	"./icons/unofficial/puzzlemaster.webp": 90339,
	"./icons/unofficial/ravenkeeper.webp": 87039,
	"./icons/unofficial/recluse.webp": 52162,
	"./icons/unofficial/revolutionary.webp": 83204,
	"./icons/unofficial/riot.webp": 68191,
	"./icons/unofficial/sage.webp": 43969,
	"./icons/unofficial/sailor.webp": 4133,
	"./icons/unofficial/saint.webp": 49246,
	"./icons/unofficial/savant.webp": 79274,
	"./icons/unofficial/scapegoat.webp": 25130,
	"./icons/unofficial/scarletwoman.webp": 47341,
	"./icons/unofficial/seamstress.webp": 42915,
	"./icons/unofficial/sentinel.webp": 49169,
	"./icons/unofficial/shabaloth.webp": 53453,
	"./icons/unofficial/shugenja.webp": 73192,
	"./icons/unofficial/slayer.webp": 90991,
	"./icons/unofficial/snakecharmer.webp": 8929,
	"./icons/unofficial/snitch.webp": 63390,
	"./icons/unofficial/soldier.webp": 61345,
	"./icons/unofficial/spiritofivory.webp": 50110,
	"./icons/unofficial/spy.webp": 29945,
	"./icons/unofficial/steward.webp": 67587,
	"./icons/unofficial/stormcatcher.webp": 45926,
	"./icons/unofficial/summoner.webp": 50593,
	"./icons/unofficial/sweetheart.webp": 38553,
	"./icons/unofficial/tealady.webp": 27837,
	"./icons/unofficial/thief.webp": 59099,
	"./icons/unofficial/tinker.webp": 76654,
	"./icons/unofficial/tor.webp": 82822,
	"./icons/unofficial/towncrier.webp": 55648,
	"./icons/unofficial/townsfolk.webp": 47436,
	"./icons/unofficial/toymaker.webp": 3465,
	"./icons/unofficial/traveller.webp": 53020,
	"./icons/unofficial/undertaker.webp": 32804,
	"./icons/unofficial/ventriloquist.webp": 4944,
	"./icons/unofficial/vigormortis.webp": 67978,
	"./icons/unofficial/villageidiot.webp": 49826,
	"./icons/unofficial/virgin.webp": 77504,
	"./icons/unofficial/vizier.webp": 30378,
	"./icons/unofficial/vortox.webp": 23627,
	"./icons/unofficial/voudon.webp": 11234,
	"./icons/unofficial/washerwoman.webp": 47797,
	"./icons/unofficial/widow.webp": 78533,
	"./icons/unofficial/witch.webp": 4544,
	"./icons/unofficial/wizard.webp": 27670,
	"./icons/unofficial/wraith.webp": 38090,
	"./icons/unofficial/xaan.webp": 46209,
	"./icons/unofficial/yaggababble.webp": 53050,
	"./icons/unofficial/zealot.webp": 96514,
	"./icons/unofficial/zenomancer.webp": 77973,
	"./icons/unofficial/zombuul.webp": 76369,
	"./leaf-left.webp": 67289,
	"./leaf-orange.webp": 87234,
	"./leaf-right.webp": 4154,
	"./leaf-top1.webp": 61614,
	"./leaf-top2.webp": 14959,
	"./leaf-top3.webp": 63372,
	"./leaf-top4.webp": 9565,
	"./leaf-top5.webp": 66002,
	"./leaf-top6.webp": 11347,
	"./leaf-top7.webp": 912,
	"./life.webp": 91427,
	"./minioninfo.webp": 87291,
	"./plus.webp": 75933,
	"./reminder.webp": 67923,
	"./shroud.webp": 56388,
	"./token.webp": 37666,
	"./vote.webp": 76061,
	"./x.webp": 69179
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6398;